export const getUserPoolNamesQuery = `query GetUserPoolNames {
    getUserPoolNames {
      id
      name
    }
}`;